import {
  getUserSelectedRegionId,
  setActiveRegionId,
} from '@sportworld/js-sdk/src/actions/region'
import { getActiveUser } from '@sportworld/js-sdk/src/actions/user'

import { StorageIds } from '@/constants/storage'
import i18n from '@/i18n'
import { ApiService } from '@/service'
import { showError } from '@/utils/utils'

export const getRegionInfo = async () => {
  try {
    return await ApiService.getRegionInfo()
  } catch {
    const user = getActiveUser()
    if (!user || user.isAnonymous) {
      showError(i18n.t('unavailableInRegion'))
    }
    return {
      currentRegionId: null,
      mainRegionId: null,
      availableRegionIds: null,
    }
  }
}

export const getRegionById = async (regionId: string) => {
  try {
    const region = await ApiService.getRegionById(regionId)
    return {
      countryCode: region.countryCodes[0],
      privacyRegulation: region.privacyRegulation,
    }
  } catch (error) {
    return {
      countryCode: '',
      privacyRegulation: '',
    }
  }
}

export const getSwCountryCode = () => {
  return localStorage.getItem(StorageIds.swCountryCode) || ''
}

const setSwCountryCode = (swCountryCode: string) => {
  localStorage.setItem(StorageIds.swCountryCode, swCountryCode)
}

export const getPrivacyRegulation = () => {
  return localStorage.getItem(StorageIds.privacyRegulation) || ''
}

const setPrivacyRegulation = (privacyRegulation: string) => {
  localStorage.setItem(StorageIds.privacyRegulation, privacyRegulation)
}

export const setActiveRegionData = (
  activeRegionId: string,
  swCountryCode: string,
  privacyRegulation: string,
) => {
  setActiveRegionId(activeRegionId)
  setSwCountryCode(swCountryCode)
  setPrivacyRegulation(privacyRegulation)
}

export const getActiveRegionData = async () => {
  const { currentRegionId, mainRegionId, availableRegionIds } =
    await getRegionInfo()
  const userSelectedRegionId = getUserSelectedRegionId(availableRegionIds)
  const activeRegionId =
    userSelectedRegionId || mainRegionId || currentRegionId || 'default'
  const { countryCode, privacyRegulation } = await getRegionById(activeRegionId)
  return { activeRegionId, countryCode, privacyRegulation }
}

export const updateActiveRegionFromBackend = async () => {
  const { activeRegionId, countryCode, privacyRegulation } =
    await getActiveRegionData()
  setActiveRegionData(activeRegionId, countryCode, privacyRegulation)
}
